import {SalesApiBase} from './paymentApi';

class SalesApi extends SalesApiBase {
}

export default new SalesApi();
